import { isOrganic } from '@itau-loans-www/utils'

const faqs = {
  title: 'Dúvidas <br /> frequentes',
  list: [
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'O que é o Saque Aniversário FGTS?',
      answer:
        'O saque aniversário permite que toda pessoa que trabalha em regime CLT possa retirar possa retirar anualmente parte do seu saldo disponível em conta(s) vinculada(s) do FGTS, no mês de seu aniversário. Para isso, é necessário aderir à modalidade saque aniversário disponível no aplicativo FGTS ou site www.fgts.caixa.gov.br.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'O que é a Antecipação do Saque Aniversário FGTS?',
      answer:
        'É um tipo de empréstimo que permite antecipar, de uma só vez, até 7 parcelas de saque aniversário do trabalhador, sem precisar esperar o mês do seu aniversário.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question:
        'O que preciso para contratar a Antecipação do Saque Aniversário FGTS?',
      answer:
        'Ser maior de 18 anos e possuir contas (ativas ou inativas) vinculadas ao FGTS, com saldo acima de R$ 250,00. Além disso, é necessário estar na modalidade FGTS de saque aniversário e ter o BANCO ITAU CONSIGNADO S.A. autorizado para consultar seu FGTS. Você pode fazer isso no aplicativo FGTS ou site <a target="_blank" href="https://www.fgts.caixa.gov.br" rel="nofollow">www.fgts.caixa.gov.br</a>.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question:
        'A Antecipação do Saque Aniversário do FGTS compromete outras linhas de crédito?',
      answer:
        'Não. Esta modalidade não compromete outras linhas de crédito. Os valores são garantidos e repassados anualmente pela Caixa Econômica Federal, ou seja, não precisa se preocupar com o pagamento das parcelas.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Posso fazer uma antecipação parcial?',
      answer: 'Sim. Não é necessário antecipar todas as 7 parcelas.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Tenho limitação de quantidade de empréstimos FGTS?',
      answer:
        'Não. Enquanto o trabalhador possuir saldo, ele pode antecipar (desde que seja acima de R$ 100,00).'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question:
        'Posso fazer uma liquidação antecipada para desbloquear meu saldo FGTS?',
      answer:
        'Sim. Porém, não é permitido liquidar o contrato com recursos do próprio FGTS.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Como sacar o seu FGTS?',
      answer:
        'Atualmente, há 2 modalidades para sacar o seu FGTS: saque-aniversário e saque-rescisão. No primeiro, o trabalhador recebe parte de seu saldo FGTS, a cada ano, no mês de seu aniversário. Já no saque-rescisão, modalidade padrão, o trabalhador recebe o saldo quando demitido sem justa causa. Aqui você pode optar pela antecipação do seu saque-aniversário, recebendo as próximas 7 parcelas do seu FGTS em sua conta em até 24 horas.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Como consultar o saldo do FGTS?',
      answer:
        'Para consultar seu saldo do FGTS basta acessar o app do FGTS CAIXA. É possível instalar o app diretamente da loja de aplicativos do seu celular. No nosso site, você pode verificar o passo a passo para fazer a sua antecipação do saque-aniversário com o Itaú.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Como antecipar o saque aniversário?',
      answer: `Para antecipar o saque aniversário, acesse o aplicativo do FGTS CAIXA e autorize o Itaú a consultar seu saldo disponível. Uma vez autorizado, basta <a href=${
        isOrganic
          ? 'https://www.itau.com.br/emprestimos-financiamentos/saque-aniversario-fgts/proposta'
          : '/saque-aniversario-fgts/proposta'
      }>clicar aqui</a> para simular sua antecipação.`
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Antecipação saque aniversário, quanto tempo cai na conta?',
      answer:
        'Aqui no Itaú sua antecipação do saque aniversario cai em até 24hrs na sua conta.'
    },
    {
      trackingId: 'trackingId',
      trackingName: 'trackingName',
      question: 'Quem tem direito ao Empréstimo FGTS?',
      answer: `Qualquer pessoa que possua saldo de FGTS maior que R$ 250,00 tem direito ao empréstimo FGTS, ou antecipação saque-aniversário. Para isso basta autorizar a consulta do seu saldo pelo Itaú e aceitar o saque-aniversário, no app do FGTS CAIXA. Ficou interessado? Faça uma simulação agora mesmo em nosso <a href=${
        isOrganic
          ? 'https://www.itau.com.br/emprestimos-financiamentos/saque-aniversario-fgts/proposta'
          : '/saque-aniversario-fgts/proposta'
      }>site</a>.`
    }
  ]
}

export default faqs
